import { useEffect, useRef, useState } from "react";

const parseNumber = (val) => {
  const cleaned = String(val).replace(/,/g, "");
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
};

export const AnimatedCounter = ({ value, suffix = "", duration = 1800, className = "" }) => {
  const target = parseNumber(value);
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min((t - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setDisplay(target * eased);
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [target, duration]);

  const formatted = target >= 100 ? Math.round(display).toLocaleString() : display.toFixed(0);
  return (
    <span ref={ref} className={className}>{formatted}{suffix}</span>
  );
};
